import { useSelector } from "react-redux";
import { selectNavStates } from "../../store/reducers/navSlice";
import React from "react";
import { getSys } from "../../api/getSys";
import { System } from "../../models/system.model";
import { getDashboardCaption } from "../../api/getDashboardCaption";
import { responseHero } from "../../utils/axiosInterceptor";
import { toast } from "react-toastify";
import { selectUser } from "../../store/reducers/userSlice";

export default function DashboardCaptionCreator () {
    const user = useSelector(selectUser);

    const [availableSystems, setAvailableSystems] = React.useState<System[]>([]);
    const [selectActiveSystem, setSelectActiveSystem] = React.useState<System>();

    const [content, setContent] = React.useState<string>("");

    React.useEffect(() => {

        const fetchSystems = async () => {
            const res = await getSys();
            setAvailableSystems(res);

            if(res.length > 0) {
                setSelectActiveSystem(res[res.length - 1]);
            }
            
        }

        fetchSystems();

    }, []);

    React.useEffect(() => {
        const fetchContent = async () => {
            const res = await getDashboardCaption(Number(selectActiveSystem?.id))
            setContent(res?.caption ?? "");
        }

        fetchContent();
    }, [selectActiveSystem]);

    const handleSelectedSystem = (system: System) => {
        setSelectActiveSystem(system);
    }

    const makeContent = async () => {

        if(!user) {
            return toast.warn("Nem vagy bejelentkezve.")
        }

        if(!selectActiveSystem) {
            return toast.warn("Nincs kiválasztva projekt.")
        }

        const data = {
            creatorId: user?.userInfo?.user_id,
            system_id: selectActiveSystem?.id,
            caption: content,
        };

        await responseHero.post(`${process.env.REACT_APP_API_URL}/dashboardcaption`, { data: data }).then((response) => {
            toast.success(`Sikeres mentés!`);
        }).catch(error => {
            console.error(JSON.stringify(error.response.data.message, null, 2));
            toast.error(`Sikertelen mentés!`);
        })
    }


    return (
        <div className="m-5">
            <p className="text-3xl mb-4">Üzenet rögzítése a kimutatásba</p>
            <div className="w-max flex space-x-4">
                {availableSystems.length === 0 ? (
                    <p>Nem található projekt az adatbázisban.</p>
                ) : (
                    <>
                        {selectActiveSystem && availableSystems.map((system, index) => (
                            <div onClick={() => handleSelectedSystem(system)} className="hover:shadow-cream hover:shadow-lg cursor-pointer rounded-lg shadow-md shadow-gray-600" key={system.id}>
                                <p className={`text-2xl px-2 py-2 font-semibold bg-dark-blue ${selectActiveSystem.id === Number(system.id) ? 'text-cream' : 'text-gray-300'}`}>{system.name}</p>
                            </div>
                        ))}
                    
                    </>
                )}
            </div>

            <div className="mt-5">
                <textarea
                rows={5}
                name="message"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Írd be a kimutatásba megjeleníteni kívánt információ szövegét..."
                ></textarea>

                <button onClick={makeContent} className="hover:bg-green-800 bg-success text-white rounded-md px-2 py-2">
                    Mentés és közzététel
                </button>

            </div>
        </div>
    )
}
